import React from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../utils';

import {
  ContentSection,
  Wrapper,
  FieldSet,
  FieldSetLabel,
  NodeList,
  NodeListItem,
  Delimiter,
  ProgressPanel,
  ProgressIndicator,
  Progress,
  ProgressText,
} from './styles';

import { RowWrapper, HubImage, NoImage, HubName, Indicators, Note, Accepted } from '../HubContentViewer/styles';

const AssignmentSection = ({ fileService, hubs = [], progress = {}, translations, isSession }) => {
  const gotoNode = (uuid) => {
    location.hash = `#${uuid}`;
  };

  const getLockState = (node) => {
    const graphNode = window.viewer.graph.cy.$(`#${node.uuid}`);
    const metaLock = graphNode.data().metaLockedBy;
    return metaLock ? metaLock : graphNode.data().lock_state;
  };

  const renderNode = (node) => {
    const {
      uuid,
      name,
      image,
      type,
      accepted,
      completed,
      hasAnyUnreadNotifications,
      hasAnnounceNotification,
      nodes = [],
    } = node;
    const lockState = getLockState(node) || 'unlocked';
    const imageUrl = getImageUrl(fileService, image, '56x56');
    const done = isSession && completed ? 'done' : '';
    const className = type ? `node ${type} ${done}` : `hub ${done} ${lockState}`;
    const noteType = hasAnyUnreadNotifications ? 'notification' : 'announcement';

    return type && lockState !== 'unlocked' ? null : (
      <React.Fragment key={uuid}>
        <NodeListItem className={className} onClick={() => gotoNode(uuid)}>
          <RowWrapper>
            <Wrapper>
              {!type && (imageUrl ? <HubImage src={imageUrl} /> : <NoImage />)}
              <HubName>{name}</HubName>
            </Wrapper>
            {isSession && (
              <Indicators>
                <Note show={hasAnyUnreadNotifications || hasAnnounceNotification} type={noteType} />
                <Accepted show={accepted} />
              </Indicators>
            )}
          </RowWrapper>
        </NodeListItem>
        <Delimiter className={className} />
        {nodes.map(renderNode)}
      </React.Fragment>
    );
  };

  const mapProgress = Object.keys(progress)
    .filter((type) => progress[type].total > 0)
    .map((type) => {
      const { text, percent } = progress[type];
      return (
        <React.Fragment key={type}>
          <ProgressIndicator>
            <Progress className={type} value={percent}></Progress>
          </ProgressIndicator>
          <ProgressText className={type}>{text}</ProgressText>
        </React.Fragment>
      );
    });

  return (
    <ContentSection>
      <FieldSet>
        <FieldSetLabel>{translations.viewer.assignment_list}</FieldSetLabel>
        {isSession && <ProgressPanel className={'ir-hide'}>{mapProgress}</ProgressPanel>}
        <NodeList>{hubs.map(renderNode)}</NodeList>
      </FieldSet>
    </ContentSection>
  );
};

export default AssignmentSection;

AssignmentSection.propTypes = {
  fileService: PropTypes.object.isRequired,
  hubs: PropTypes.array.isRequired,
  progress: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  isSession: PropTypes.bool.isRequired,
};
